import rmskincareAPI from '../utils/rmskincareAPI'

const storageApi = {
  //Purchase Record
  getOrFilterPurchasesRecord: async (query) =>{
    const result = await rmskincareAPI.get(
      `/management/product/record/find${query}`
    )
    return result.data.data
  },

  //Inventory Record
  getOrFilterInventoryRecord: async (query)=>{
    const result = await rmskincareAPI.get(
      `/management/product/storage/find${query}`
  )
  return result.data.data
  },

  //add 
  addInventoryRecord : async(requestBody)=>{
    const result=await rmskincareAPI.post(
      `/management/product/storage/addList` ,requestBody
    )
    return result.data.data

  },

  //update

  updateInventoryRecord: async (requestBody)=>{
    const result =await rmskincareAPI.post(
      `/management/product/storage/update` , requestBody
    )
    return result.data.data
  },

  //delete
  deleteInventoryRecord: async (InventoryProductId)=>{
    let requestBody=[InventoryProductId]
    const result =await rmskincareAPI.post(
      `/management/product/storage/del` , requestBody
    ) 
    return result
  },

  //Stock
  getOrFilterProductStockRecord: async (query)=> {
    const result =await rmskincareAPI.get(
      `/management/product/store/find${query}`
    )
    return result.data.data
  },
 
  updateProductStock : async(requestBody)=>{
    const result =await rmskincareAPI.post(
    `/management/product/store/update`,requestBody
    )
    return result.data.data
  },

  //Low Stock Alert
  getProductLowStockList: async(query)=>{
    const result = await rmskincareAPI.get(
      `/management/product/store/alarm${query}`
    )
    return result.data.data
  },

}

export default storageApi
